import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiAuthMethodsGet200ResponseInner, AuthMethodsService, AuthenticationMethodConfigurationService, CredentialResetProxyService, CredentialResetService } from '../../services/identity';
import { Observable, Subscription } from 'rxjs';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { ConstantService, ThemeEnum } from '../../services/common/constant.service';
import { EnrollmentInputModel } from '../../shared/enrollment/models/enrollmentinput.model';
import { EnrollmentOptionsService } from '../../services/common/enrollment-options';

@Component({
  selector: 'app-credential-reset-enrollment',
  standalone: false,
  templateUrl: './credential-reset-enrollment.component.html',
  styleUrl: './credential-reset-enrollment.component.scss'
})
export class CredentialResetEnrollmentComponent implements OnInit, OnDestroy {

  private subscriptions = new Subscription;

  private logoImage: string;

  private orgId: number;
  private orgName: string;
  private userId: number;
  private username: string;

  private hideFirstFactor: boolean;
  private hideSecondFactor: boolean;

  private isLoaded: boolean;

  private options: EnrollmentInputModel;

  private isComplete: boolean;
  constructor(
    private router: Router,
    private constantService: ConstantService,
    private credentialResetProxyService: CredentialResetProxyService,
    private enrollmentOptions: EnrollmentOptionsService
    
  ) { }
  ngOnInit(): void {

    const logoImage = this.constantService.getSessionStorage(ThemeEnum.mainLogo);
    this.logoImage = logoImage ?? "assets/images/se-white-logo.png";

    this.subscriptions.add(
      this.credentialResetProxyService.apiCredentialResetProxyGetSessionInfoGet()
        .subscribe({
          next: async data => {
            this.orgId = data.orgId;
            this.orgName = data.orgName;
            this.userId = data.userId;
            this.username = data.username;
            if (data.factors == "PasswordFirstFactor") {
              this.hideFirstFactor = true;
            } else if (data.factors == "PasswordSecondFactor") {
              this.hideSecondFactor = true;
            }

            this.options = await this.enrollmentOptions.createOptions(
              this.orgId,
              this.orgName,
              this.userId,
              this.username,
              true,
              'user',
              false,
              this.hideFirstFactor,
              false,
              this.hideSecondFactor,
              false,
              false,
              true,
            true);
            this.options.functions
            this.subscriptions.add(
              this.credentialResetProxyService.apiCredentialResetProxyGetAuthMethodConfigGet()
                .subscribe({
                  next: data => {
                    this.options.currentUser.id = this.userId;
                    this.options.currentUser.username = this.username;
                    this.options.functions.getOrgSettings = this.getOrgSettings.bind(this);
                    this.options.functions.getConfig = this.getConfig.bind(this);
                    this.options.functions.getAuthMethods = this.getAuthMethods.bind(this);
                    this.options.functions.saveAuthMethods = this.saveAuthMethods.bind(this); 
                    this.options.functions.getHardwareTokens = this.getHardwareTokens.bind(this);
                    this.options.functions.softtoken.userEnrolReadyStatus = this.userEnrolReadyStatus.bind(this)
                    this.options.functions.softtoken.userSeedUrl = this.userSeedUrl.bind(this);
                    this.options.functions.fido.getCredentialOptions = this.getCredentialOptions.bind(this);
                    this.options.functions.fido.identifyToken = this.identifyToken.bind(this);

                    this.isLoaded = true;
                  },
                  error: error => { }
                })
            )

          },
          error: (error: HttpErrorResponse) => {
            if (error.status == 401) {
              this.router.navigate(['login']);
            }
          }
        })
    )
  }

  continue() {
    this.subscriptions.add(
      this.credentialResetProxyService.apiCredentialResetProxyCompleteOtherMethodResetPost()
        .subscribe({
          next: _ => {
            this.isComplete = true;
          },
          error: error => {
            console.log(error);
          }
        })
    )
  }

  logout() {
    this.subscriptions.add(
      this.credentialResetProxyService.apiCredentialResetProxyCompleteOtherMethodResetPost()
        .subscribe({
          next: _ => {
            this.router.navigate(['login']);
          },
          error: error => {
            this.router.navigate(['login']);
          }
        })
    )
  }

  private getBasicUserInfo(username: string, orgId: string): Observable<any> {
    return this.credentialResetProxyService.apiCredentialResetProxyGetBasicUserInfoGet();
  }

  private getOrgSettings(organizationId: number, groupKey: string): Observable<any> {
    return this.credentialResetProxyService.apiCredentialResetProxyGetOrgSettingsGet();
  }

  private getConfig(orgId: number, userId: number): Observable<any> {
    return this.credentialResetProxyService.apiCredentialResetProxyGetAuthMethodConfigGet();
  }

  private getAuthMethods(): Observable<any> {
    return this.credentialResetProxyService.apiCredentialResetProxyGetAuthMethodsGet();
  }

  private saveAuthMethods(methods: ApiAuthMethodsGet200ResponseInner[]): Observable<any> {
    return this.credentialResetProxyService.apiCredentialResetProxySaveAuthMethodsPost(methods);
  }

  private getHardwareTokens(orgId: number, username: string): Observable<any> {
    return this.credentialResetProxyService.apiCredentialResetProxyGetHardwareTokensGet();
  }

  private userEnrolReadyStatus(isSoftTokenOnly: boolean): Observable<any> {
    return this.credentialResetProxyService.apiCredentialResetProxyUserEnrolReadyStatusGet();
  }

  private userSeedUrl(isSoftTokenOnly: boolean, isGenericToken: boolean): Observable<any> {
    return this.credentialResetProxyService.apiCredentialResetProxyUserSeedUrlGet();
  }

  private getCredentialOptions(orgName: string, username: string, isUsernameless: boolean): Observable<any> {
    return this.credentialResetProxyService.apiCredentialResetProxyGetCredentialOptionsGet();
  }

  private identifyToken(orgName: string, username: string, credentialId: string): Observable<any> {
    return this.credentialResetProxyService.apiCredentialResetProxyIdentifyTokenPost();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
